import React from "react";
export default function Newsletter() {
  return (
    <section className="bg-white">
      {/* <div className="mx-auto max-w-7xl px-4 py-8 grid md:grid-cols-2 items-center gap-4">
        <div>
          <h4 className="text-lg md:text-xl font-bold">Never Miss an Event</h4>
          <p className="text-sm text-slate-600">Get the best events delivered to your inbox.</p>
        </div>
        <form className="flex gap-2">
          <input className="flex-1 rounded-xl border px-4 py-3" placeholder="Enter your email" />
          <button className="rounded-xl bg-amber-400 px-5 py-3 font-semibold text-slate-900">Subscribe</button>
        </form>
      </div> */}
    </section>
  );
}
